import DashboardIcon from '@repo/ui/components/icons/sidebar/DashboardIcon';
import MaintenanceIcon from '@repo/ui/components/icons/sidebar/MaintanceIcon';
// import MessagesIcon from '@repo/ui/components/icons/sidebar/messages';
import SupportIcon from '@repo/ui/components/icons/sidebar/ChatIcon';
import TwoUsersIcon from '@repo/ui/components/icons/sidebar/TwoUsersIcon';
import AddClient from '@repo/ui/components/icons/AddClient';
import UsersIcon from '@repo/ui/components/icons/sidebar/UsersIcon';
import LocationIcon from '@repo/ui/components/icons/sidebar/LocationIcon';
import People from '@repo/ui/components/icons/People';
import { BarChart3, CircleDollarSign, Package, ShoppingCart } from 'lucide-react';

export const navigationBottom = [
    // { name: 'messages', icon: MessagesIcon, activeIcon: MessagesIcon, to: '' },
    {
        name: 'settings',
        icon: MaintenanceIcon,
        activeIcon: MaintenanceIcon,
        to: '/settings',
        // requiresPermission: 'list_setting',
    },
    // { name: 'help_and_support', icon: SupportIcon, activeIcon: SupportIcon, to: '' },
];

export const customerRelations = [
    {
        name: 'add_client',
        to: '/customer-relations/add-customer',
        // requiresPermission: 'create_customer',
    },
    { name: 'customer_communication', to: '/customer-relations/customer-communication' },
    { name: 'archive', to: '/customer-relations/archive' },
];

// // Service
export const ReportsSide = [
    { name: 'customer', to: '/reports/customer' },
    { name: 'marketing', to: '/reports/marketing' },
    {
        name: 'services_and_orders',
        to: '/reports/services-and-orders',
    },
    {
        name: 'branches_and_employees',
        to: '/reports/branches-and-employees',
    },
];

export const navigation = [
    { name: 'dashboard', icon: DashboardIcon, activeIcon: DashboardIcon, to: '/' },
    {
        name: 'customer_relations',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        to: '/customer-relations',
        navigation: customerRelations,
        // requiresPermission: 'list_customer',
    },
 

    {
        name: 'service',
        icon: People,
        activeIcon: People,
        to: '/services',
        // requiresPermission: 'list_service',
    },
    {
        name: 'printed_items',
        icon: Package,
        activeIcon: Package,
        to: '/products',
        // requiresPermission: 'list_product',
    },
    {
        name: 'order',
        icon: AddClient,
        activeIcon: AddClient,
        to: '/orders',
        // requiresPermission: 'list_order',
    },
    {
        name: 'customer_by_type',
        icon: ShoppingCart,
        activeIcon: ShoppingCart,
        to: '/sales',
        // requiresPermission: 'list_customer',
    },
    {
        name: 'marketing',
        to: '/marketing',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        // requiresPermission: 'list_marketing',
    },
    {
        name: 'employees',
        icon: UsersIcon,
        activeIcon: UsersIcon,
        to: '/human-resources/employees',
        // requiresPermission: 'list_user',
    },
    {
        name: 'branches',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/branches',
        // requiresPermission: 'list_branch',
    },
    {
        name: 'finance',
        icon: CircleDollarSign,
        activeIcon: CircleDollarSign,
        to: '/finance',
        // requiresPermission: 'list_finance',
    },
    {
        name: 'reports',
        icon: BarChart3,
        activeIcon: BarChart3,
        to: '/reports',
        navigation: ReportsSide,
        // requiresPermission: 'list_report',
    },
    {
        name: 'permissions',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/permissions-page',
        // requiresPermission: 'list_role',
    },
    {
        name: 'subscriptions',
        icon: SupportIcon,
        activeIcon: SupportIcon,
        to: '/subscriptions',
        // requiresPermission: 'list_subscription',
    },
];
